import { Component } from '@angular/core';

@Component({
  selector: 'earned-value-info',
  templateUrl: './earned-value-info.component.html',
})
export class EarnedValueInfoComponent {}
